import type {DiscoverMapShare} from '../media/discoverMapSession';
export type MapPoint=DiscoverMapShare&{latitude:number;longitude:number;pointAt:string};
export type MapCanvasProps={points:readonly MapPoint[];selected:number|null;fit:number;
  onSelect:(id:number)=>void;onFailure:()=>void;label:string;};
export function mapPoints(shares:readonly DiscoverMapShare[]):MapPoint[]{
  return shares.filter((s):s is MapPoint=>s.latitude!==null&&s.longitude!==null&&s.pointAt!==null);
}
/** Unwrap the shortest longitude arc, including points across the date line. */
export function mapBounds(points:readonly MapPoint[]):[[number,number],[number,number]] {
  if(!points.length)return [[-60,-120],[70,120]];
  const sorted=points.map(p=>(p.longitude+360)%360).sort((a,b)=>a-b);
  let gap=-1,start=sorted[0];
  sorted.forEach((lon,i)=>{const next=sorted[(i+1)%sorted.length]+(i===sorted.length-1?360:0);
    if(next-lon>gap){gap=next-lon;start=next%360;}});
  const lons=points.map(p=>{let lon=(p.longitude+360)%360;if(lon<start)lon+=360;return lon;});
  const shift=(Math.min(...lons)+Math.max(...lons))/2>180?360:0;
  return [[Math.min(...points.map(p=>p.latitude)),Math.min(...lons)-shift],
    [Math.max(...points.map(p=>p.latitude)),Math.max(...lons)-shift]];
}
